import { service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { pushAndReturnPayload } from 'frontend-utils/utils/ember-data';
import { formatUrl } from 'frontend-utils/utils/url/format-url';
import type AjaxService from 'lumen/services/ajax';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

interface SubscriptionChannelDistributionPayload {
  currency: string;
  room_price_vat_rate: number | null;
}

export default class SubscriptionChannelDistribution extends Model {
  [Type] = 'subscription/channel-distribution' as const;

  @attr('string') declare currency: string;
  @attr('number') declare roomPriceVatRate: number | null;

  @service declare ajax: AjaxService;

  async saveForSubscription(
    subscriptionId: string,
  ): Promise<SubscriptionChannelDistribution> {
    const data = this.serialize() as Record<string, unknown>;

    const url = formatUrl(
      `/${APIGATEWAY}/configure/subscription/channel-distribution`,
      { subscription_id: subscriptionId },
      this.ajax.host,
    );

    const response: SubscriptionChannelDistributionPayload =
      await this.ajax.request(url, {
        data: JSON.stringify(data),
        method: this.isNew ? 'POST' : 'PUT',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      });

    super.rollbackAttributes();

    const normalisedResponse = pushAndReturnPayload(
      this.store,
      {
        'subscription-channel-distributions': [
          { ...response, id: subscriptionId },
        ],
      },
      'subscription/channel-distribution',
    );

    return (
      normalisedResponse[
        'subscription-channel-distributions'
      ] as SubscriptionChannelDistribution[]
    )[0]!;
  }
}
